import React from 'react';
import { Button } from '@fluentui/react-components';
import { ArrowLeft24Regular, Delete16Regular, Edit16Regular } from '@fluentui/react-icons';
import type { UserPromptOption } from '../../../hooks/useSavedPrompt';
import { useSuggestedPromptsMenuStyles } from './SuggestedPromptsMenu';

interface SavedPromptsViewProps {
    userPrompts: UserPromptOption[];
    onBack: () => void;
    onPromptSelect: (prompt: string) => void;
    onEditPrompt: (prompt: UserPromptOption) => void;
    onDeletePrompt: (prompt: UserPromptOption) => void;
}

const SavedPromptsView: React.FC<SavedPromptsViewProps> = ({
    userPrompts,
    onBack,
    onPromptSelect,
    onEditPrompt,
    onDeletePrompt,
}) => {
    const styles = useSuggestedPromptsMenuStyles();

    return (
        <>
            <div className={styles.backButtonContainer}>
                <Button
                    appearance="transparent"
                    className={styles.backButton}
                    icon={<ArrowLeft24Regular />}
                    onClick={onBack}
                >
                    Back
                </Button>
            </div>
            <div className={styles.entriesScrollArea}>
                {userPrompts.length === 0 ? (
                    <div className={styles.emptyText}>No saved prompts yet.</div>
                ) : (
                    userPrompts.map((prompt) => (
                        <Button
                            key={prompt.id}
                            appearance="transparent"
                            className={styles.promptButton}
                            onClick={() => onPromptSelect(prompt.text)}
                        >
                            <div className={styles.promptContent}>
                                <span className={styles.promptText}>{prompt.text}</span>
                            </div>
                            <div className={styles.promptActions} onClick={(event) => event.stopPropagation()}>
                                <Button
                                    appearance="subtle"
                                    icon={<Edit16Regular />}
                                    className={styles.actionButton}
                                    aria-label="Edit saved prompt"
                                    onClick={() => onEditPrompt(prompt)}
                                />
                                <Button
                                    appearance="subtle"
                                    icon={<Delete16Regular />}
                                    className={styles.actionButton}
                                    aria-label="Delete saved prompt"
                                    onClick={() => onDeletePrompt(prompt)}
                                />
                            </div>
                        </Button>
                    ))
                )}
            </div>
        </>
    );
};

export default SavedPromptsView;
